import { createAction } from '../../../redux/customActions';

export const Actions = {
    setAccessApplication: (accessApplication: string) =>
        createAction('client/setAccessApplication', accessApplication),
};
